module.exports = __webpack_public_path__ + "img/cs4.54701c1d.jpg";